import Vue from "vue";
import Vuex from "vuex";
import user from "./user";
import appData from "./appData";
import settings from "./settings";
import library from "./library";
import moment from "moment";
import { AIAddOnGetters } from 'bh-mod';

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		user,
		settings,
		appData,
		library,
	},
	state: {
		$p: null,
		instance: null,
		loading: false,
		folders: [],
		theApp: {},
		featureStates: {},
		rightBar: "",
		selectedChart: {},
		currentStartDate: moment()
			.subtract(30, "days")
			.endOf("day")
			.format("x"),
		currentEndDate: moment()
			.endOf("day")
			.format("x"),
		compareStartDate: null,
		compareEndDate: null,
		records: {
			lead: {
				all: [],
				sources: [],
				opportunities: [],
			},
			inventory: {
				lots: [],
				elevations: [],
				priceHistory: {
					lots: [],
					elevation: [],
					units: [],
					premiums: [],
					addOns: [],
				},
			},
			pipeline: {
				all: [],
				tasks: [],
			},
			sales: [],
			ai: {
				coverage: [],
				analytics: [],
				leadPath: [],
				callEffectiveness: [],
			},
			survey: [],
			tasks: [],
		},
		fileStructure: [],
		selectedProjects: ['all'],
		pdfOrientation: "portrait",
		selectedSurvey: null,
		chartType: "bar",
		selectedDomain: null,
	},
	mutations: {
		SET_SELECTED_PROJECTS(state, data = ['all']) {
			state.selectedProjects = data;
		},
		SET_PDF_ORIENTATION(state, data = "portrait") {
			state.pdfOrientation = data;
		},
		SET_SURVEY(state, data) {
			state.selectedSurvey = data;
		},
		SET_CHART_TYPE(state, data = "bar") {
			state.chartType = data;
		},
		SET_FILE_STRUCTURE(state, data) {
			state.fileStructure = data;
		},
		SET_$P(state, value) {
			state.$p = value;
		},
		OPEN_RIGHT_BAR(state, data) {
			state.rightBar = data;
		},
		CLOSE_RIGHT_BAR(state) {
			state.rightBar = "";
		},
		LOAD: (state, bool = !state.loading) => state.loading = bool,
		PAGE_BUTTONS(state, buttons) {
			state.pageButtons = buttons;
		},
		SET_APP(state, data) {
			state.theApp = data;
		},
		SET_FEATURE_STATES(state, data) {
			state.featureStates = data;
		},
		SET_INSTANCE: (state, data) => {
			state.instance = data;
			state.cats = data.activeApps;
		},
		updateSelectedChart: (state, chartDetails) => {
			const chartData = chartDetails;
			delete chartData.link;
			state.selectedChart = chartData;
		},
		setCurrentDates(state, { startDate, endDate }) {
			state.currentStartDate = startDate;
			state.currentEndDate = endDate;
		},
		setCompareDates(state, { startDate, endDate }) {
			state.compareStartDate = startDate;
			state.compareEndDate = endDate;
		},
		setRecords(state, { type, records }) {
			state.records[type] = records;
		},
		SET_DOMAIN: (state, data) => {
			state.selectedDomain = data;
		},
	},
	getters: {
		hasWorksheetAppAccess(state) {
			return !!state.instance?.apps?.find(app => app.subdomain === "worksheets");
		},
		...AIAddOnGetters,
	},

});
